/**
 * Internal helpers for the tax library.
 */

/** Round to 2 decimal places (paisa precision), half-up. */
export function r2(n: number): number {
  if (!Number.isFinite(n)) {
    throw new RangeError(`r2: non-finite ${n}`);
  }
  const sign = n < 0 ? -1 : 1;
  return sign * Math.round(Math.abs(n) * 100) / 100;
}

/** Round to 4 decimal places, half-up. Used for rates / ratios. */
export function r4(n: number): number {
  if (!Number.isFinite(n)) {
    throw new RangeError(`r4: non-finite ${n}`);
  }
  const sign = n < 0 ? -1 : 1;
  return sign * Math.round(Math.abs(n) * 10000) / 10000;
}

/** Ensure a value is a finite non-negative number. */
export function ensureNonNegative(n: number, fnName: string): number {
  if (typeof n !== "number" || !Number.isFinite(n)) {
    throw new RangeError(`${fnName}: expected a finite number, got ${n}`);
  }
  if (n < 0) {
    throw new RangeError(`${fnName}: expected non-negative, got ${n}`);
  }
  return n;
}

/** Ensure a value is a finite number. */
export function ensureFinite(n: number, fnName: string): number {
  if (typeof n !== "number" || !Number.isFinite(n)) {
    throw new RangeError(`${fnName}: expected a finite number, got ${n}`);
  }
  return n;
}

/** Clamp `n` to `[min, max]`. */
export function clamp(n: number, min: number, max: number): number {
  if (n < min) return min;
  if (n > max) return max;
  return n;
}
